import Api from '@/services/Api';
import axios from 'axios';

export default {
    //get( this.urlRichieste + 'accredito/' + this.idNota,
    caricaNota(id) {
        return Api().get('/accredito/' + id);
    },

    createNota(dati) {
        return Api().post('/accredito', dati);
    },
    
    deleteNota(id) {
        return Api().delete('/accredito/' + id);
    },

    getNoteCredito() {
        return Api().get('/accredito');
    },

    updateNota(id, dati) {
        return Api().put('/accredito/' + id, dati);
    },

    changePage(page, n_righe) {
        return Api().get('/accredito?page=' + page + '&limit=' + n_righe);
    },

    // GET /accredito/check/:token?note=..
    sendNote(token, note) {
        return axios.create({
            baseURL: 'https://sviluppoallergeni.confcom.it',
            withCredentials: true,
            headers: {
              'Content-type': 'multipart/form-data',
            }
          }).get('/accredito/check/'+token+'?note='+note);
    },

    getRichiedenti: async function(idSede) {
        // GET /users?filter=true&sede=:idsede
        return Api().get('/users?filter=true&sede=' + idSede);

    },

    getStatusNote: async function() {
        return Api().get('/accredito/status')
    },

    esportaFile: async function() {
        return Api().get('/accredito/csv');
    },
}